import { DateTime } from 'luxon';

import { generateWeekDays } from 'src/common/date/generateWeekDays';

export function useWeekDays(dateISO: string) {
  return generateWeekDays(DateTime.fromISO(dateISO));
}
